module.exports = __webpack_public_path__ + "static/media/ic-callkit-screen-share.07b7f98a.webp";